import { Row, Col,Container } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Menu = ({ isOpen, toggleMenu }) => {
  return (
    <>
    {isOpen && (<div className="cart-backdrop" onClick={toggleMenu}></div>)}
    <div className={`menu-sidebar ${isOpen ? 'open' : ''}`}>
        <Row>
        <Link to="/10-گردنبند" onClick={toggleMenu}>
            <label>گردنبند</label>
        </Link>
        </Row>
        
        <Row>
        <Link to="/17-دستبند" onClick={toggleMenu}>
            <label>دستبند</label>
        </Link>
        </Row>
        <Row>
        <Link to="/11-گوشواره" onClick={toggleMenu}>
            <label>گوشواره</label>
        </Link>
        </Row>
        <Row>
        <Link to="/15-انگشتر" onClick={toggleMenu}>
            <label>انگشتر</label>
        </Link>
        </Row>
        <Row>
        <Link to="/21-آویز" onClick={toggleMenu}>
            <label>آویز</label>
        </Link>
        </Row>
        <Row>
        <Link to="/14-پابند" onClick={toggleMenu}>
            <label>پابند</label>
        </Link>
        </Row>
        <Row>
        <Link to="/22-مردانه" onClick={toggleMenu}>
            <label>مردانه</label>
        </Link>
        </Row>
        <Row>
        <Link to="/115-کودک" onClick={toggleMenu}>
            <label>کودک</label>
        </Link>
        </Row>
        <Row>
        <Link to="/101-قفل" onClick={toggleMenu}>
            <label>قفل</label>
        </Link>
        </Row>
        <Row>
            <Link to="/159-برندها" onClick={toggleMenu}>
                <label>برندها</label>
            </Link>
        </Row>
    </div>
    </>
  );
}
export default Menu;